import { Modal, Space } from 'antd';
import { Trans } from 'react-i18next';

import { JobPostingActionModal } from './VacancyActions';

const ConcludeVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, ...props }) => {
  return (
    <Modal {...props}>
      <Space direction="vertical">
        {jobPosting.filled_positions < jobPosting.positions && (
          <span>
            <Trans>
              A vaga <strong>{jobPosting.name}</strong> não pode ser concluída, pois tem apenas{' '}
              {jobPosting.filled_positions} pessoa(s) contratada(s) que é inferior a quantidade de{' '}
              {jobPosting.positions} posições definidas durante a abertura da vaga. Altere o número
              de posições editando a vaga antes de concluí-la.
            </Trans>
          </span>
        )}
        {jobPosting.filled_positions >= jobPosting.positions && (
          <>
            <span>
              <Trans>
                Lembrete: Você já <b>enviou feedback para todos os candidatos?</b> Lembre-se que
                falta de retorno do processo seletivo é o principal motivo de insatisfação com a
                empregadora e isso pode afetar a sua atração no longo prazo.
              </Trans>
            </span>
            <div>
              <Trans>
                Tem certeza que deseja concluir a vaga <strong>{jobPosting.name}</strong>?
              </Trans>
            </div>
          </>
        )}
      </Space>
    </Modal>
  );
};

export default ConcludeVacancyModal;
